import { NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useIntl } from 'react-intl';
import markdown from '../data/staticPages/fashionunited-newsletter.md';
import Layout from '../components/Layout';
import LinkAndAnchor from '../components/LinkAndAnchor';
import HomeLink from '../components/HomeLink';
import Head from '../components/Head';
import messages from '../lib/messages.json';
import Markdown from '../components/Markdown';

const FashionUnitedNewsletterPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="fashionunited-newsletter"
      passHref
    >
      {intl.formatMessage(messages['fashionUnitedNewsletterInfo.title'])}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(
          messages['fashionUnitedNewsletterInfo.title'],
        )}
        description={intl.formatMessage(
          messages['fashionUnitedNewsletterInfo.title'],
        )}
      />
      <StaticPageComponent
        content={<Markdown markdown={markdown} />}
        title={intl.formatMessage(
          messages['fashionUnitedNewsletterInfo.title'],
        )}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

FashionUnitedNewsletterPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default FashionUnitedNewsletterPage;
